import { cn } from '../../utils/cn';
import { HTMLAttributes, forwardRef } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  isHoverable?: boolean;
  isGlass?: boolean;
}

const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ className, isHoverable = false, isGlass = false, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          'rounded-2xl overflow-hidden',
          'bg-white card-shadow',
          isGlass && 'glass',
          isHoverable && 'transition-all duration-300 hover:card-shadow-hover hover:scale-[1.02] cursor-pointer',
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Card.displayName = 'Card';

export default Card;
